module.exports = __webpack_public_path__ + "static/media/frame15.c70d4ef9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/frame-bottom/frame15.png
// module id = 88
// module chunks = 0